import { INCLUDE_IN_EMAIL, INCLUDE_IN_REPORTING, IS_REVIEW_COMPLETED, THREE_PS_DATA_UID, USER_DEFINED_DESCRIPTION, USER_DEFINED_EMAIL_DESCRIPTION } from './threePsCodes.constants';
import { ISaveThreePsCodePayload, IThreePsCodeItem } from './threePsCodes.model';

export const hasValidationErrors = (rows: IThreePsCodeItem[]): boolean =>
    rows.some(
        (row) =>
            (row[INCLUDE_IN_EMAIL] && !row[USER_DEFINED_EMAIL_DESCRIPTION]?.trim()) ||
            (row[INCLUDE_IN_REPORTING] && !row[USER_DEFINED_DESCRIPTION]?.trim())
    );

export const hasRowChanged = (
    currentRow: IThreePsCodeItem,
    originalRow: IThreePsCodeItem
): boolean =>
    currentRow[USER_DEFINED_DESCRIPTION] !== originalRow[USER_DEFINED_DESCRIPTION] ||
    currentRow[USER_DEFINED_EMAIL_DESCRIPTION] !== originalRow[USER_DEFINED_EMAIL_DESCRIPTION] ||
    currentRow[INCLUDE_IN_REPORTING] !== originalRow[INCLUDE_IN_REPORTING] ||
    currentRow[INCLUDE_IN_EMAIL] !== originalRow[INCLUDE_IN_EMAIL] ||
    currentRow[IS_REVIEW_COMPLETED] !== originalRow[IS_REVIEW_COMPLETED];

export const buildSavePayload = (
    rows: IThreePsCodeItem[]
): ISaveThreePsCodePayload[] =>
    rows.map((row) => ({
        [THREE_PS_DATA_UID]: row[THREE_PS_DATA_UID],
        [USER_DEFINED_DESCRIPTION]: row[USER_DEFINED_DESCRIPTION],
        [USER_DEFINED_EMAIL_DESCRIPTION]: row[USER_DEFINED_EMAIL_DESCRIPTION],
        [INCLUDE_IN_REPORTING]: row[INCLUDE_IN_REPORTING],
        [INCLUDE_IN_EMAIL]: row[INCLUDE_IN_EMAIL],
        [IS_REVIEW_COMPLETED]: row[IS_REVIEW_COMPLETED],
    }));

export const getOriginalByIdMap = (
    rows: IThreePsCodeItem[]
): Map<string, IThreePsCodeItem> =>
    new Map(rows.map((row) => [row[THREE_PS_DATA_UID], row] as const));

export const getChangedRows = (
    editableRows: IThreePsCodeItem[],
    originalRows: IThreePsCodeItem[]
): IThreePsCodeItem[] => {
    const originalById = getOriginalByIdMap(originalRows);

    return editableRows.filter((row) => {
        const originalRow = originalById.get(row[THREE_PS_DATA_UID]);
        return originalRow ? hasRowChanged(row, originalRow) : false;
    });
};

export const hasUnsavedChanges = (
    editableRows: IThreePsCodeItem[],
    originalRows: IThreePsCodeItem[]
): boolean => {
    if (editableRows.length !== originalRows.length) return true;

    const originalById = getOriginalByIdMap(originalRows);

    return editableRows.some((row) => {
        const baseRow = originalById.get(row[THREE_PS_DATA_UID]);
        return !baseRow || hasRowChanged(row, baseRow);
    });
};